import { useSelector } from 'react-redux';
import { useState, useEffect, useRef } from 'react';

import { useAppDispatch } from '../../../hooks';
import { useApiHandler } from './hooks/useApiHandler';
import { ROOT_STATE } from '../../../store/store.types';
import { configs } from '../../../constants/configs/configs';
import { API_STATUS_CODES, defaultPageInfo } from '../../../constants/common.constants';
import { getViewDetailUrl, processTicketData } from './constants/ticketlist.utils';
import { TICKET_LIST_ACTION_TYPES } from '../../../constants/actionTypes/tikcetListActionTypes';
import { DEFAULT_PAYLOAD, SearchType, workgroupOptions } from './constants/ticketlist.constants';

export const useTicketListContainer = () => {
    const { deafultListAPI, controllerAPI, claimNewTicketAPI } = useApiHandler();
    const dispatch = useAppDispatch();
    const isInitialLoad = useRef(true);
    const [pageSortInfo, setPageSortInfo] = useState({...defaultPageInfo, sortField: '', sortOrder: '' });
    const [selectedSearchType, setSelectedSearchType] = useState(SearchType.DEFAULT);

    const ticketsData = useSelector((state: ROOT_STATE) => state.ticketMgmt.ticketsList.tickets) || {};
    const tickets = ticketsData.ticketListJson || [];
    const searchCriteria = ticketsData.searchCriteriaJson || {};
    const ticketsCount = ticketsData.count || 0;

    const ticketController = useSelector((state: ROOT_STATE) => state.ticketMgmt.ticketsList.controller) || {};
    const { enableTicketSupport, viewTicketPermission } = ticketController;
    const userticketQueues =
        useSelector((state: ROOT_STATE) => state.ticketMgmt.ticketsList.controller.userticketQueues) || [];

    const {
        isOpen: isErrorModalOpen,
        errorMessage,
        modalTitle,
    } = useSelector((state: ROOT_STATE) => state.ticketMgmt.ticketsList.errorModalData);
    const isAdvanceSearch = selectedSearchType === SearchType.ADVANCE;

    useEffect(() => {
        fetchIntialController();
        isInitialLoad.current = false;
    }, []);

    useEffect(() => {
        if (!isAdvanceSearch) fetchDefaultTickets();
    }, [isAdvanceSearch]);

    const modifiedWorkgroupOptions = [
        ...workgroupOptions,
        ...userticketQueues.map(queue => ({ value: queue.name, text: queue.name })),
    ];

    const onClaimNewTicket = async (workgroup: string = 'Any') => {
        const payload = { workGroup: workgroup, csrftoken: window.csrf_token };
        const { data, statusCode } = (await claimNewTicketAPI(dispatch, payload)) || {};
        if (statusCode === API_STATUS_CODES.OK) {
            window.location.href = getViewDetailUrl(data);
        }
    };

    const onAddNewTicket = async () => {
        const url = new URL(configs.endpoints.TICKET_MGMT_CREATE_PAGE, window.location.origin);
        window.location.href = url.toString();
    };

    const fetchDefaultTickets = () => {
        const payload = { ...DEFAULT_PAYLOAD, csrftoken: window.csrf_token };
        deafultListAPI(dispatch, payload);
    };

    const fetchIntialController = async () => {
        await controllerAPI(dispatch, {});
    };

    const onErrorModalClose = () => {
        dispatch({
            type: TICKET_LIST_ACTION_TYPES.SET_DATA_ERROR,
            payload: { isOpen: false, errorMessage: '', modalTitle: '' },
        });
    };

    return {
        fetchDefaultTickets,
        setSelectedSearchType,
        isAdvanceSearch,
        pageSortInfo,
        setPageSortInfo,
        tickets: processTicketData(tickets, ticketController),
        searchCriteria,
        ticketsCount,
        isInitialLoad,
        onClaimNewTicket,
        onAddNewTicket,
        workgroupOptions: modifiedWorkgroupOptions,
        onErrorModalClose,
        isErrorModalOpen,
        errorMessage,
        modalTitle,
        enableTicketSupport,
        viewTicketPermission,
    };
};
